import React, { useContext, useState, useEffect } from 'react';
import { systemCode, xs_sessionToken, xs_languageCode } from '../..';
import { ControlPanelContext } from '../../data/control-panel-context/ControlPanelConf';
import { TicketPrinterContext } from '../../data/printer/TicketPrinterContext';
import { getConfiguration, getSysDateInFormat, formatDate, getCurrencyValue, classIf } from '../../data/utils';
import { setDraggable, setResizable } from '../../draggable-resizable';
import { getLabel } from '../../data/labels';

function PrintTickets(props) {

	const idPvr = props.idPvr == null? '' : (props.idPvr + '');
	const $ = window.$;
	const filters = {
			'ALL' : 255,
			'ACTIVE' : 0,
			'WINNING' : 1,
			'LOSING' : 2,
			'TO_BE_PAID' : 3,
			'PAID' : 5
	};
	const conf = getConfiguration();
	//states
	const [ticketData, setTicketData] = useState({data :[], state : 'not_loaded'});
	const [dateFrom, setDateFrom] = useState(getSysDateInFormat('YYYY-MM-DD', -1));
	const [dateTo, setDateTo] = useState(getSysDateInFormat('YYYY-MM-DD', 0));
	const [selectedFilter, setFilter] = useState(filters['ALL']);
	const [nickname, setNickname] = useState('');
	const ticketPrinterContext = useContext(TicketPrinterContext);
	function setDate(where, value){
		let from = dateFrom;
		let to = dateTo;
		if(where === 'from'){
			from = value;
		}
		else{
			to = value;
		}
		// checking dates integrity
		const minorDateOk = from <= to;
		
		if(!minorDateOk){
			//date to is lower than date from: I switch them
			from = to;
			to = dateFrom;
		}
		setDateFrom(from);
		setDateTo(to);
	}
	
	function searchTickets(){
		const url = conf['api']['searchTickets'];
		if(dateFrom === '' || dateTo === ''){
			return;
		}
		const dateFromParam = dateFrom.replace(/-/g, '') + ' 00:00';
		const dateToParam = dateTo.replace(/-/g, '') + ' 23:59';
		setTicketData({data :[], state : 'loading'});
		const params = {
			 systemCode,
			 lingua : xs_languageCode,
			 token : xs_sessionToken,
			 hash : '',
			 nickname,
			 dateFrom : dateFromParam, 
			 dateTo : dateToParam, 
			 idPvr, 
			 state : selectedFilter
		};
		$.ajax({
    		type: "POST",
    		url : url + "?" +  window.$.param(params),
    		async : true,
    		success : (data) => {
    			if(data != null){
    				data = JSON.parse(data);
    				setTicketData({
    					data : data.tickets.reverse(),
    					state : 'loaded'
    				});
    			}
    		},
    		error : (errorData) => {
				setTicketData({
					data : ticketData.data,
					state : 'loaded'
				});
    		}	
       });
	   return false;
	}

	const controlPanelContext = useContext(ControlPanelContext);
	
	useEffect(() =>{
		setDraggable('search-ticket-dialog');
		setResizable('search-ticket-dialog');
	}, []);
	
	return (
	    <div id="search-ticket-dialog" className={"finestra-stampa-ticket draggable-element resizable-element bordo-tondo" + classIf(ticketData.state === 'loading', 'blur-dialog')} style={{left: "50%", top: "25%"}}>
	        <div className="finestra-stampa-ticket-contenitore-interno">
	            <div className="finestra-stampa-ticket-intestazione bordo-tondo">
	                <div>
	                    <p>{getLabel('control_panel.print_tickets.title')}</p>
	                </div>
	                <button onClick={() => { controlPanelContext.setStatusTicketBox('close') }}><i className="fas fa-times-circle fa-lg"></i></button>
	            </div>
	            <div className="finestra-stampa-ticket-contenitore-ricerca-e-risultati">
	                <div className="finestra-stampa-ticket-barra-ricerca">
	                    <form onSubmit={(e) => {e.preventDefault(); searchTickets();} }>
	                        <select value={selectedFilter} name="search-ticket-in-state" id="search-ticket-in-state" onChange={(e) => setFilter(e.target.value)}>
	                            <option value={filters['ALL']}>{getLabel('control_panel.print_tickets.search_tickets.filter.all')}</option>
	                            <option value={filters['ACTIVE']}>{getLabel('control_panel.print_tickets.search_tickets.filter.active')}</option>
	                            <option value={filters['WINNING']}>{getLabel('control_panel.print_tickets.search_tickets.filter.winning')}</option>
	                            <option value={filters['LOSING']}>{getLabel('control_panel.print_tickets.search_tickets.filter.losing')}</option>
	                            {conf.nas == false &&
                                    <> 
	                                	<option value={filters['TO_BE_PAID']}>{getLabel('control_panel.print_tickets.search_tickets.filter.payable')}</option>
	                                	<option value={filters['PAID']}>{getLabel('control_panel.print_tickets.search_tickets.filter.paid')}</option>
	                            	</>
	                            }
	                        </select>
	                        {idPvr.length > 0 && (
                                <input onChange={(e) =>  setNickname(e.target.value)} id="search-ticket-username" placeholder={getLabel('general.username')} type="text" value={nickname} />
                            )}
	                        <input onChange={(e) => setDate("from", e.target.value)} id="search-ticket-from" type="date" value={dateFrom} />
	                        <input onChange={(e) => setDate("to", e.target.value)} id="search-ticket-to" type="date" value={dateTo} />
	                        <input type="submit" value={getLabel('general.find')} />
	                    </form>
	                </div>
	                <div className="finestra-stampa-ticket-risultati-ricerca">
	                    <table>
	                        <thead>
                                {ticketData.data.length > 0 ?
                                    (<tr>
                                        <th>{getLabel('control_panel.print_tickets.search_results.header.state')}</th>
                                        <th>{getLabel('control_panel.print_tickets.search_results.header.date')}</th>
                                        <th>{getLabel('control_panel.print_tickets.search_results.header.ticket_id')}</th>
                                        <th>{getLabel('control_panel.print_tickets.search_results.header.amount')}</th>
                                        <th>{getLabel('control_panel.print_tickets.search_results.header.winnings')}</th>
                                        <th></th>
                                    </tr>)
                                    :
                                    (<tr><th></th></tr>)
                                }
	                        </thead>
	                        <tbody>
	                        {ticketData.data.length === 0 && ticketData.state === 'loaded' && (
	                        	<tr>
	                        		<td>{getLabel('control_panel.print_tickets.search_results.not_ticket_found')}</td>
	                        	</tr>
	                        )}
	                        {ticketData.data.map(function(ticket) {
                                const reactKey = 'ticket-' + ticket.id;
                                return (
                                    <tr key={reactKey}>
                                        <td>{ticket.descStatus}</td>
                                        <td>{formatDate(ticket.timestamp).formatted}</td>
                                        <td>{ticket.id}</td>
                                        <td>{getCurrencyValue(ticket.amount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</td>
                                        <td>{getCurrencyValue(ticket.win, conf.cs.m, conf.cs.nd, conf.cs.ct)}</td>
                                        <td><button onClick={() => {ticketPrinterContext.printTicket(ticket.id)} } className="finestra-stampa-ticket-bottone-stampa"><i className="fas fa-print"></i></button></td>
                                    </tr>
                                )
	                        })}
	                        </tbody>
	                    </table>
	                </div>
	            </div>
	        </div>
            <div className="resizable-corner-icon">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 301.41 301.41">
                    <path className="resize-corner-icon-svg" d="M72.5,300.5" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M98.5,289.5" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M139.5,291.5" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M125.5,300.5" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M23.51,277.49" transform="translate(0.71 0.71)"></path>
                    <line className="resize-corner-icon-svg" x1="0.71" y1="300.71" x2="300.71" y2="0.71"></line>
                    <path className="resize-corner-icon-svg" d="M98.5,300.5" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M93.11,295" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M119.11,284" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M160.11,286" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M146.11,295" transform="translate(0.71 0.71)"></path>
                    <path className="resize-corner-icon-svg" d="M44.13,272" transform="translate(0.71 0.71)"></path>
                    <line className="resize-corner-icon-svg" x1="200.71" y1="300.71" x2="300.71" y2="200.71"></line>
                    <path className="resize-corner-icon-svg" d="M119.11,295" transform="translate(0.71 0.71)"></path>
                    <line className="resize-corner-icon-svg" x1="100.71" y1="300.71" x2="300.71" y2="100.71"></line>
                </svg>
            </div>
        </div>
	);
}

export default PrintTickets;